// This file configures the initialization of Sentry for edge features (middleware, edge routes, and so on).
// The config you add here will be used whenever one of the edge features is loaded.
// Note that this config is unrelated to the Vercel Edge Runtime and is also required when running locally.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import { BrowserOptions } from '@sentry/nextjs'

import { isDevelopment } from '@shared/util'
import { isE2E } from '@shared/util/env'

const dsn =
    process.env.SENTRY_DSN || "https://8757ab63d5a842d69add259495c1327a@o177913.ingest.us.sentry.io/1385134"

export const config: BrowserOptions = {
  dsn,
  enabled: !isDevelopment() && !isE2E(),
  environment: process.env.SENTRY_ENVIRONMENT,
  tracesSampleRate: 0.1,
  // ignore api routes
  ignoreTransactions: [/^\/api(\/.*)?$/],
}
